// extracted by mini-css-extract-plugin
export default {"container":"Main_screen_container__oGnwY","mainWrapper":"Main_screen_mainWrapper__5WWFM"};